import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  className?: string;
  items: { value: string; label: string }[];
}

const PageHeaderSubtitle = (props: Props) => {
  const { className, items } = props;
  const { t } = useTranslation();

  const renderItems = () =>
    items.map((x, i) => (
      <div key={x.label} style={{ alignItems: 'baseline', whiteSpace: 'nowrap' }}>
        {i !== 0 && <span className="divider">/</span>}
        <span className="bold">{`${t(x.label)}: `}</span>
        <span>{x.value}</span>
      </div>
    ));
  return <div className={`page-subtitle ${className || ''}`}>{renderItems()}</div>;
};

export default PageHeaderSubtitle;
